import { 
	COMPANIES_UPDATE_SUCCESS,
	COMPANIES_USER_ADD_SUCCESS,
	SHOW_ALL_PACKAGES_FLAG_SET,
	DESKTOP_APP_FLAG_SET,
	DESKTOP_APP_FLAG_GET,
	UPGRADE_POPUP_FLAG_SET,
	PENDING_TRIGGER_CHECKOUT_FLAG_SET,
	COUPON_ID_PROVIDED_FLAG_SET,
	DISCOUNT_CLEAR_APPLIED,
	SUBSCRIPTION_CATEGORY_SET,
	SUBSCRIPTION_BATCH_PARAMS_SET,
	SUBSCRIPTION_VIEW_SET,
	SUBSCRIPTION_PERIOD_SET,
	SUBSCRIPTION_CURRENCY_SET,
	SEATS_QUANTITY_SET,
	LICENSES_QUANTITY_SET,
	COUPON_APPLY_WITHOUT_VALIDATION,
	COUPON_FETCH_SUCCESS,
	COUPON_FETCH,
	PERPETUAL_APP_FLAG_SET,
	DESKTOP_TRIAL_FLAG_SET,
	DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET,
	DISCOUNT_APPLY_MAGIX,
	DISCOUNT_APPLY_COUPON_SET_ID,
	SUBSCRIPTION_CLEAR_STATE,
	SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED,
	SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED,
	REDUCE_USERS_API_ERROR_STATE_SET,
	REDUCE_USERS_API_ERROR_STATE_CLEAR,
	MODAL_HIDE,
	MODAL_RESET,
	RENEWAL_POPUP_SHOWN
} from './actions';
import { isNewRealEstateUiUsed } from 'utils/state';
import { filterNonGuestUsers } from 'utils/users';
import { getDesktopAppCompanyId, saveDesktopAppCompanyId, clearDesktopAppCompanyId } from 'utils/storage';
import { resolveActiveCompanyId } from 'redux/modules/companies';
import store from '../../redux/store';
import { getCurrentPlanId, convertPlanIdIntoSubscription } from 'utils/subscription';
import { PACKAGES_CONFIG } from 'config';
import _ from 'lodash';

import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import Logger from '../../logger/logger';
const log = Logger.get('redux-app');

const initialState = {
	isDesktopApp: false,
	isPerpetualApp: false,
	isDesktopTrial: null,
	isReAccessNoIndustry: null,
	showAllPackages: false,
	isUpgradePopup: false,
	pendingTriggerCheckout: null,
	isCouponIdProvided: false,
	subscriptionCategory: null,
	subscriptionPeriod: null,
	isPeriodAutoApplied: null,
	isCategoryAutoApplied: null,
	isCurrencyAutoApplied: null,
	isSeatsQuantityAutoApplied: null,
	isLicensesQuantityAutoApplied: null,
	isSubscriptionViewAutoApplied: null,
	subscriptionCurrency: null,
	subscriptionView: null,
	seatsQuantity: null,
	licensesQuantity: null,
	wasPlusOverviewPageVisited: false,
	wasPerpetualOverviewPageVisited: false,
	reduceUsersApiState: null,
	wasRenewalPopupShown: false
};

export default (state = initialState, action) => {
	
	switch (action.type) {

		case REDUCE_USERS_API_ERROR_STATE_SET: {
			return {
				...state,
				reduceUsersApiState: action.payload
			};
		}

		case MODAL_HIDE:
		case MODAL_RESET:
		case REDUCE_USERS_API_ERROR_STATE_CLEAR: {
			if (state.reduceUsersApiState) {
				return {
					...state,
					reduceUsersApiState: null
				};
			} else {
				return state;
			}
		}

		case DISCOUNT_CLEAR_APPLIED: {
			return {
				...state,
				isUpgradePopup: false,
				isCouponIdProvided: false,	
				isPeriodAutoApplied: false,
				isCategoryAutoApplied: false
			};
		}		

		case PERPETUAL_APP_FLAG_SET: {
			return {
				...state,
				isPerpetualApp: action.payload
			};
		}

		case DESKTOP_TRIAL_FLAG_SET: {
			return {
				...state,
				isDesktopTrial: action.payload
			};
		}

		case DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET: {
			return {
				...state,
				isReAccessNoIndustry: action.payload
			};
		}

		case DESKTOP_APP_FLAG_SET: {
			return {
				...state,
				isDesktopApp: action.payload
			};
		}

		case DESKTOP_APP_FLAG_GET: {
			return {
				...state,
				isDesktopApp: action.payload
			};
		}

		case SHOW_ALL_PACKAGES_FLAG_SET: {
			return {
				...state,
				showAllPackages: action.payload
			};
		}

		case UPGRADE_POPUP_FLAG_SET: {
			return {
				...state,
				isUpgradePopup: action.payload
			};
		}

		case PENDING_TRIGGER_CHECKOUT_FLAG_SET: {
			return {
				...state,
				pendingTriggerCheckout: action.payload
			};
		}
		
		case COUPON_ID_PROVIDED_FLAG_SET: {
			return {
				...state,
				isCouponIdProvided: action.payload
			};
		}

		case SUBSCRIPTION_BATCH_PARAMS_SET: {
			const newState = {...state}; 

			if (action.payload.subscriptionCategory) {
				newState.subscriptionCategory = action.payload.subscriptionCategory;
				newState.isCategoryAutoApplied = true;
			}

			if (action.payload.subscriptionView) {
				newState.subscriptionView = action.payload.subscriptionView;
				newState.isSubscriptionViewAutoApplied = false;
			}

			if (action.payload.subscriptionPeriod) {
				newState.subscriptionPeriod = action.payload.subscriptionPeriod;
				newState.isPeriodAutoApplied = true;
			}

			return newState;
		}

		case SUBSCRIPTION_CATEGORY_SET: {
			return {
				...state,
				subscriptionCategory: action.payload.value,
				isCategoryAutoApplied: action.payload.isAutoApplied
			};
		}

		case SUBSCRIPTION_VIEW_SET: {
			return {
				...state,
				subscriptionView: action.payload.value,
				isSubscriptionViewAutoApplied: action.payload.isAutoApplied
			};
		}

		case SUBSCRIPTION_PERIOD_SET: {
			return {
				...state,
				subscriptionPeriod: action.payload.value,
				isPeriodAutoApplied: action.payload.isAutoApplied
			};
		}

		case COUPON_APPLY_WITHOUT_VALIDATION: {
			return {
				...state,
				isPeriodAutoApplied: action.payload.isAutoApplied,
				isCategoryAutoApplied: action.payload.isAutoApplied
			};
		}

		case COUPON_FETCH: {
			return {
				...state,
				isPeriodAutoApplied: false,
				isCategoryAutoApplied: false
			};
		}
		
		case COUPON_FETCH_SUCCESS: {
			return {
				...state,
				isPeriodAutoApplied: action.payload.isAutoApplied,
				isCategoryAutoApplied: action.payload.isAutoApplied
			};
		}

		case RENEWAL_POPUP_SHOWN: {
			return {
				...state,
				wasRenewalPopupShown: true
			};
		}

		case DISCOUNT_APPLY_COUPON_SET_ID: {
			return {
				...state,
				isPeriodAutoApplied: true,
				isCategoryAutoApplied: true
			};
		}
			
		case DISCOUNT_APPLY_MAGIX: {
			return {
				...state,
				isPeriodAutoApplied: true,
				isCategoryAutoApplied: true
			};
		}

		case SUBSCRIPTION_CURRENCY_SET: {
			return {
				...state,
				subscriptionCurrency: action.payload.value,
				isCurrencyAutoApplied: action.payload.isAutoApplied
			};
		}

		case SEATS_QUANTITY_SET: {
			return {
				...state,
				seatsQuantity: action.payload.value,
				isSeatsQuantityAutoApplied: action.payload.isAutoApplied
			};
		}

		case LICENSES_QUANTITY_SET: {
			return {
				...state,
				licensesQuantity: action.payload.value,
				isLicensesQuantityAutoApplied: action.payload.isAutoApplied
			};
		}		

		case COMPANIES_UPDATE_SUCCESS: {
			const companyData = getCompanyData(true);
			if (companyData.selectedId) {
				const { data } = action.payload;

				if (!_.get(data, 'users')) {
					const nError = new AppError({
						message: 'Missing data.users in COMPANIES_UPDATE_SUCCESS',
						errorId: ERRORS.UNKNOWN,
						details: {
							action: JSON.stringify(action.payload)
						},
						visualisers: { feature: 'REDUX_APP' }
					});
					log.send(nError);							
				}

				if (isNewRealEstateUiUsed(store)) {
					return { ... state };
				} else {
					return { ... state, seatsQuantity: filterNonGuestUsers(data.users).length };
				}
				
			} else {
				return { ... state };
			}
		}

		case COMPANIES_USER_ADD_SUCCESS: {
			const companyData = getCompanyData(true);
			if (companyData.selectedId) {
				if (isNewRealEstateUiUsed(store)) {
					return { ... state, seatsQuantity: 0 };
				} else {
					return { ... state, seatsQuantity: companyData.nrOfUsers };
				}
			} else {
				return { ... state };
			}
		}

		case SUBSCRIPTION_CLEAR_STATE: {
			return {
				...state,
				isPerpetualApp: false,
				showAllPackages: true,
				isUpgradePopup: false,
				subscriptionCategory: null,
				subscriptionPeriod: null,
				isPeriodAutoApplied: null,
				isCategoryAutoApplied: null,
				wasPlusOverviewPageVisited: false,
				wasPerpetualOverviewPageVisited: false,
				//productQuantity: null,
				isSubscriptionViewAutoApplied: null,
				subscriptionView: null
			};
		}

		case SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED: {
			return {
				...state,
				wasPerpetualOverviewPageVisited: true
			};
		}
		
		case SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED: {
			return {
				...state,
				wasPlusOverviewPageVisited: true
			};
		}

		default:
			return state;

	}
};

export const setAllPackagesShownFlag = (value) => {
	return {
		type: SHOW_ALL_PACKAGES_FLAG_SET,
		payload: value
	};	
};

export const setDesktopUserFlag = (value) => {
	const result = value && !isCloudPlan() ? true : false;
	// Save flag when providing ?desktop-app=1 for the first time
	const companyId = resolveActiveCompanyId(true);
	result && saveDesktopAppCompanyId(companyId);
	
	return {
		type: DESKTOP_APP_FLAG_SET,
		payload: result
	};	
};

export const setDesktopTrialFlag = (value) => {
	return {
		type: DESKTOP_TRIAL_FLAG_SET,
		payload: value
	};	
};

export const setReAccessNoIndustry = (value) => {
	return {
		type: DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET,
		payload: value
	};	
};

export const setPerpetuallAppFlag = (value) => {
	return {
		type: PERPETUAL_APP_FLAG_SET,
		payload: value
	};	
};

export const setUpgradePopupFlag = (value) => {
	return {
		type: UPGRADE_POPUP_FLAG_SET,
		payload: value
	};	
};

export const setPendingTriggerCheckout = (value) => {
	return {
		type: PENDING_TRIGGER_CHECKOUT_FLAG_SET,
		payload: value
	};	
};


export const setCouponIdProvidedFlag = (value) => {
	return {
		type: COUPON_ID_PROVIDED_FLAG_SET,
		payload: value
	};	
};

/**
 * Retrieves the isDesktopApp flag from sessionstorage
*/
export const getDesktopAppFlag = () => {
	const isDesktopApp = resolveDesktopAppFlag();
	return {
		type: DESKTOP_APP_FLAG_GET,
		payload: isDesktopApp
	};
};

const isCloudPlan = () => {
	let result = false;

	const state = store.getState();
	const companiesRawData = _.get(state, 'companies.rawDataById');

	const selectedPlanId = companiesRawData
		?
		getCurrentPlanId(companiesRawData[state.companies.selectedId])
		:
		null;

	if (selectedPlanId) {
		const activeSubscription = convertPlanIdIntoSubscription(selectedPlanId);
		const { plan } = activeSubscription;
		result = PACKAGES_CONFIG[plan].isCloudSuitePlan;
	}
	return result;
};

const getCompanyData = (onlyNonGuests) => {
	const state = store.getState();
	const allUsers = _.get(state, 'companies.byId[' + state.companies.selectedId + '].users');

	const selectedPlanId = getCurrentPlanId(state.companies.rawDataById[state.companies.selectedId]);
	let plan;
	if (selectedPlanId) {
		const activeSubscription = convertPlanIdIntoSubscription(selectedPlanId);
		({ plan } = activeSubscription);
	}

	return {
		selectedId: state.companies.selectedId,
		nrOfUsers: onlyNonGuests ? filterNonGuestUsers(allUsers).length : allUsers.length,
		plan
	};
};

const resolveDesktopAppFlag = () => {
	const savedDesktopAppCompanyId = getDesktopAppCompanyId();
	if (savedDesktopAppCompanyId) {
		// Check if saved isDesktopApp flag applies to current company
		// or company changed in current tab
		const companyId = resolveActiveCompanyId(true);

		if (savedDesktopAppCompanyId === companyId && !isCloudPlan()) {
			return true;
		} else {
			clearDesktopAppCompanyId();
			return false;
		}
	} else {
		return false;
	}
};

/* only to be used when changing state from Subscription > Your Products > Upgrade plan */
export const setAppStateParams = (props) => {
	return {
		type: SUBSCRIPTION_BATCH_PARAMS_SET,
		payload: props
	};	
};

export const setSubscriptionCategory = (value, isAutoApplied) => {
	return {
		type: SUBSCRIPTION_CATEGORY_SET,
		payload: {
			value,
			isAutoApplied
		}
	};	
};

export const setSubscriptionView = (value, isAutoApplied) => {
	return {
		type: SUBSCRIPTION_VIEW_SET,
		payload: {
			value,
			isAutoApplied
		}
	};	
};

export const setSubscriptionPeriod = (value, isAutoApplied) => {
	return {
		type: SUBSCRIPTION_PERIOD_SET,
		payload: {
			value,
			isAutoApplied
		}
	};	
};

export const setSubscriptionCurrency = (value, isAutoApplied) => {
	return {
		type: SUBSCRIPTION_CURRENCY_SET,
		payload: {
			value,
			isAutoApplied
		}
	};	
};

export const clearSubscriptionState = () => {
	return {
		type: SUBSCRIPTION_CLEAR_STATE
	};	
};

export const setPerpetualOverviewPageVisited = () => {
	return {
		type: SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED
	};	
};

export const setPlusOverviewPageVisited = () => {
	return {
		type: SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED
	};	
};

export const setSeatsQuantity = (value, isAutoApplied) => {
	return {
		type: SEATS_QUANTITY_SET,
		payload: {
			value,
			isAutoApplied
		}
	};
};

export const setLicensesQuantity = (value, isAutoApplied) => {
	return {
		type: LICENSES_QUANTITY_SET,
		payload: {
			value,
			isAutoApplied
		}
	};
};

export const setReduceUsersApiErrorState = (props) => {
	return {
		type: REDUCE_USERS_API_ERROR_STATE_SET,
		payload: props
	};
};

export const clearReduceUsersApiErrorState = () => {
	return {
		type: REDUCE_USERS_API_ERROR_STATE_CLEAR
	};
};

export const setRenewalPopupWasShown = (props) => {
	return {
		type: RENEWAL_POPUP_SHOWN
	};
};



// WEBPACK FOOTER //
// ./src/redux/modules/app.js